module.exports = {
  apiUrl: "http://localhost:7000/api/",
  baseUrl: "https://simdan-url.herokuapp.com"
  //  /apiUrl: "http://shortener.muhzi.com/v1/api/",
  // baseUrl: "http://muhzi.com"
};



// WEBPACK FOOTER //
// ./src/config/constants.js